import React from 'react';

import { Box } from 'styles/box';

import { Description, Error, Label, Wrapper } from './styles';

export interface Props {
  children: React.ReactNode;
  type?: string;
  width?: number;
  label?: string;
  notionLink?: string; // Link to notion for documentation
  description?: string;
  error?: string | undefined;
  mandatory?: boolean;
  hidden?: boolean;
  disableMargin?: boolean;
}

const Field: React.FC<Props> = ({
  children,
  width,
  label,
  description,
  notionLink,
  error,
  type,
  mandatory = false,
  hidden = false,
  disableMargin = false,
}) => {
  if (hidden) return null;

  return (
    <Wrapper
      width={width ?? 100}
      typeToggle={type == 'TOGGLE'}
      className={type}
      disableMargin={disableMargin}>
      {label && (
        <Box display="flex" flexDirection="column">
          <Label typeToggle={type == 'TOGGLE'}>
            {label}
            {mandatory && ' *'}
          </Label>
          {description && (
            <Description>
              {description}{' '}
              {notionLink && (
                <a href={notionLink} target="_blank" rel="noopener noreferrer">
                  Notion
                </a>
              )}
            </Description>
          )}
        </Box>
      )}
      {children}
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default Field;
